"use client";

import { useStore } from "@tanstack/react-store";
import { Store } from "@tanstack/store";
import { useEffect } from "react";
import { loadProductIndex } from "./all-products";
import { loadCustomizations } from "./customizations-store";
import { loadFavoriteProducts } from "./favorite-products";
import { loadRecentSearches } from "./recent-searches";
import { loadShoppingProducts } from "./shopping-products";

export const storesLoadedStore = new Store(false);

export const loadAllStores = () => {
  const start = Date.now();
  loadProductIndex();
  loadFavoriteProducts();
  loadShoppingProducts();
  loadRecentSearches();
  loadCustomizations();

  console.log(`All stores loaded in ${Date.now() - start}ms`);
};

export function StoresLoader({ children }: { children: React.ReactNode }): React.ReactNode {
  const storesLoaded = useStore(storesLoadedStore);
  useEffect(() => {
    if (storesLoaded) return;
    loadAllStores();
    storesLoadedStore.setState(() => true);
  }, [storesLoaded]);

  return <>{children}</>;
}
